import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoginService } from '@pxl/models/contracts';
import { AccountRoutingRouteNames, AppRoutingRouteNames } from '@pxl/route-names';

export const logoutGuard: CanActivateFn = async () => {
    const router = inject(Router);
    await inject(LoginService).logoutUser(true, false);
    return router.createUrlTree([AppRoutingRouteNames.SignIn, AccountRoutingRouteNames.Login]);
};
